<h3>Uw {{ productName }}</h3>
<wuc-rack *ngIf="purchasedProduct" gridGap="medium">
    <wuc-display-field>
        <label>Kenteken</label>
        <span>{{ purchasedProduct?.product?.car?.licensePlate | kenteken }}</span>
        <wuc-link *ngIf="canBeReplaced" slot="action" (clicked)="replaceCar()" type="secondary">Wijzigen</wuc-link>
    </wuc-display-field>
    <wuc-display-field>
        <label>Merk</label>
        <span>
            {{ purchasedProduct?.product?.car?.motorVehicleMake }}
            {{ purchasedProduct?.product?.car?.motorVehicleType }}
            <ng-container *ngIf="purchasedProduct?.product?.car?.motorVehicleType">
                <wuc-drop-trigger position="top">
                <span slot="trigger">
                    <span class="text">
                        <wuc-icon-ui size="xs" type="primary" icon="information"></wuc-icon-ui>
                    </span>
                </span>
                    <wuc-balloon minWidth="34rem">
                        Is dit niet helemaal uw type? Geen zorgen, we verzekeren de uitvoering die bij uw kenteken
                        hoort.
                    </wuc-balloon>
                </wuc-drop-trigger>
            </ng-container>
        </span>
    </wuc-display-field>
    <wuc-display-field>
        <label>Afgifte kenteken</label>
        <span>{{ purchasedProduct?.product?.car?.licencePlateIssuedDate | dateFormat }}</span>
    </wuc-display-field>
</wuc-rack>
